import { useContext } from "react";
import { AdminThemeContext } from "./adminThemeDefs";
import type { AdminThemeContextType } from "./adminThemeDefs";

export function useAdminTheme(): AdminThemeContextType {
  const ctx = useContext(AdminThemeContext);
  if (!ctx) {
    throw new Error("useAdminTheme must be used within AdminThemeProvider");
  }
  return ctx;
}
